(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["pw-header"]) return;
  try {
    
document.querySelectorAll('.pw-mobile-nav').forEach(menu => {
  menu.querySelectorAll('a').forEach(link => link.addEventListener('click', () => menu.removeAttribute('open')));
  menu.addEventListener('keydown', event => {
    if (event.key === 'Escape') {
      menu.removeAttribute('open');
      menu.querySelector('summary').focus();
    }
  });
});

  } catch(e) { console.error(e); }
})();
})();
